import { IProductDTO } from '../../../legacy/shared-types';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { btlProductApi } from '../../../api/product';

export const useBtlProductByAppId = (appId?: string): UseQueryResult<IProductDTO[]> =>
  useQuery(['btl-products-list', appId], () => (appId ? btlProductApi.getBtlProductsByAppId(appId) : {}), {
    enabled: !!appId,
  });
